<div *ngIf="toggled && showMinimize" class="jmCollapseTitleLearnMore">
	<div class="jmPageTitle" style="padding-top: 10px;">
		Begin Career Exploration
		<div class="jmWidgetControlContainer jmWidgetRightControlContainer fa fa-plus-square" role="button" (click)="toggleCollapse()"></div>
	</div>
</div>
<div *ngIf="!toggled" class="h-100">
	<div class="h-100 jmWidgetPadding bg-white">
		<div *ngIf="showMinimize" class="jmPageTitle">
			Begin Career Exploration
			<div role="button" (click)="toggleCollapse()" class="jmWidgetControlContainer jmWidgetRightControlContainer fa fa-minus-square"></div>
		</div>

		<div style="display: flex; flex-direction: column;" class="w-100 text-center" [ngStyle]="showMinimize? {'height':'325px' }:{'height':'100%'}">
			<div *ngIf="!showMinimize" class="jmPageTitle text-start">Begin Career Exploration</div>
			<div style="display: flex; align-items: center; flex-direction: column; padding: 10px 0 10px 0;">
				<img src="assets/images/splash_career_explore.png" class="circleImageScale" />
			</div>
			<div style="margin-bottom: auto; overflow-y: auto;">We like your adventurous spirit. Search for a career that aligns with your interests and Learn More about it.</div>
			<div style="display: flex; flex-direction: column;">
				<button style="align-self: flex-start; margin-left: auto; margin-right: auto;" class="btn btn-primary" (click)="exploreCareers($event)">Explore Careers</button>
				<img src="assets/images/blank.png" style="height: 15px; width: auto; align-self: flex-start; margin-left: auto; margin-right: auto; margin-top: 5px;" />
			</div>
		</div>
	</div>
</div>
